// extracted by mini-css-extract-plugin
module.exports = {"root":"Card_root__zdP6c","content":"Card_content__RZer2","text":"Card_text__Jeli_","slider":"Card_slider__puPL3"};